
export enum RatingCurrencyCd {
	CANADIAN_DOLLAR = 'CanadianDollar',
	US_DOLLAR = 'UsDollar'}

